import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(private http: HttpClient) {}

  getContentLanguages(): Promise<any> {
    const params = new HttpParams().set("v", 2);
    return new Promise((resolve, reject) => {
      this.http.get('../../../../assets/data/content-languages.json', { params }).subscribe(
        (response: any) => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }
}
